import { Flex, Grid, Text } from '@pega/cosmos-react-core';
import React from 'react';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';

export interface DisplayCustomerInfoProps {
  customerData: any;
}

const DisplayCustomerInfo: React.FC<DisplayCustomerInfoProps> = ({ customerData }) => {
  const translate = useLocalTranslation();

  return (
    <Flex container={{ direction: 'column', alignItems: 'start', gap: 2 }} style={{ paddingLeft: '1rem' }}>
      <Text variant="h3">{translate('task')}</Text>
      {customerData.task?.simulationScenario && (
        <Grid>
          <Text variant="h5">{translate('simulation_scenario')}</Text>
          <Text variant="secondary">{customerData.task?.simulationScenario}</Text>
        </Grid>
      )}
      {customerData.task?.queueName && (
        <Grid>
          <Text variant="h5">{translate('queue_name')}</Text>
          <Text variant="secondary">{customerData.task?.queueName}</Text>
        </Grid>
      )}
      {customerData.task?.personality && (
        <Grid>
          <Text variant="h5">{translate('personality')}</Text>
          <Text variant="secondary">{customerData.task?.personality}</Text>
        </Grid>
      )}
      {customerData.task?.painPoints && (
        <Grid>
          <Text variant="h5">{translate('pain_points')}</Text>
          <Text variant="secondary">{customerData.task?.painPoints}</Text>
        </Grid>
      )}
    </Flex>
  );
};

export default DisplayCustomerInfo;
